// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-text-products-logos {
  display: block;
  margin-top: 2rem;
  max-width: -moz-fit-content;
  max-width: fit-content;
  text-align: center;
  margin-bottom: 2rem;
}

.loading-text-product-page {
  display: block;
  max-width: -moz-fit-content;
  max-width: fit-content;
  text-align: center;
}

.loading-div-products {
  display: block;
}

.flex-hat-products-right-column {
  max-width: max-content;
}
/* .flex-hat-products-right-column {
  max-width: 55rem;
} */

/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
    sm, small: 600px
    md, medium: 900px
    lg, large: 1200px
    xl, extra-large: 1536px */
  /* 
  @media only screen and (width < 845px) {
    .hat-column-right-products,
    .flex-hat-products-right-column {
      max-width: 40rem;
    }
  }

  @media only screen and (width < 814px) {
    .hat-column-right-products,
    .flex-hat-products-right-column {
      max-width: 39rem;
    }
  } */
  /* @media only screen and (width < 400px) {
    .flex-hat-products-right-column {
    }
  }
  
  @media only screen and (width >= 400px) {
    .hat-column-right-products {
    }
  }
  @media only screen and (width >= 500px) {
    .flex-hat-products-right-column {
    }
  }
  @media only screen and (width >= 600px) {
    .flex-hat-products-right-column {
    }
  }
  @media only screen and (width >= 768px) {
    .flex-hat-products-right-column {
    }
  }
  @media only screen and (max-width: 1087px) {
    .flex-hat-products-right-column {
      max-width: 54rem;
    }
  }

  @media only screen and (width >= 1200px) {
    .flex-hat-products-right-column {
    }
  } */
}

/*Max-width is basically saying 500px, if youre in that this will happen*/
@media all {
  /* xs, extra-small: 0px
    sm, small: 600px
    md, medium: 900px
    lg, large: 1200px
    xl, extra-large: 1536px */

  @media only screen and (max-width: 844px) {
    .flex-hat-products-right-column,
    .loading-div-products,
    .bottom-text-products-logos {
      margin-left: 2rem;
    }
  }

  @media only screen and (min-width: 845px) {
    .flex-hat-products-right-column {
      margin-left: 0rem;
    }
  }
  /* Extra small devices (phones, 600px and down) */
  /* @media only screen and (width >= 400px) {
    .hat-column-right-products {
      margin-left: 4rem;
      max-width: fit-content;
    }
  } */
  /* @media only screen and (width >= 500px) {
    .hat-column-right-products {
      margin-left: 7rem;
      max-width: fit-content;
    }
  } */
  /* Small devices (portrait tablets and large phones, 600px and up) */
  /* @media only screen and (width >= 600px) {
    .hat-column-right-products {
      margin-left: 0rem;
      max-width: fit-content;
    }
  } */
  /* Medium devices (landscape tablets, 768px and up) */
  /* @media only screen and (width >= 768px) {
    .hat-column-right-products {
      margin-left: 7rem;
      max-width: fit-content;
    }
  } */
  /* Large devices (laptops/desktops, 992px and up) */
  /* @media only screen and (width >= 992px) {
    .hat-column-right-products {
      margin-left: 3rem;
    }
  } */
  /* Extra large devices (large laptops and desktops, 1200px and up) */
  /* @media only screen and (width >= 1200px) {
    .hat-column-right-products {
      margin-left: 10rem;
    }
  } */
}
`, "",{"version":3,"sources":["webpack://./src/Products/Products.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAAsB;EAAtB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,2BAAsB;EAAtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;AACA;;GAEG;;AAEH,yEAAyE;AACzE;EACE;;;;6BAI2B;EAC3B;;;;;;;;;;;;;KAaG;EACH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA8BG;AACL;;AAEA,yEAAyE;AACzE;EACE;;;;6BAI2B;;EAE3B;IACE;;;MAGE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,iBAAiB;IACnB;EACF;EACA,iDAAiD;EACjD;;;;;KAKG;EACH;;;;;KAKG;EACH,oEAAoE;EACpE;;;;;KAKG;EACH,qDAAqD;EACrD;;;;;KAKG;EACH,mDAAmD;EACnD;;;;KAIG;EACH,oEAAoE;EACpE;;;;KAIG;AACL","sourcesContent":[".bottom-text-products-logos {\n  display: block;\n  margin-top: 2rem;\n  max-width: fit-content;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.loading-text-product-page {\n  display: block;\n  max-width: fit-content;\n  text-align: center;\n}\n\n.loading-div-products {\n  display: block;\n}\n\n.flex-hat-products-right-column {\n  max-width: max-content;\n}\n/* .flex-hat-products-right-column {\n  max-width: 55rem;\n} */\n\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n    sm, small: 600px\n    md, medium: 900px\n    lg, large: 1200px\n    xl, extra-large: 1536px */\n  /* \n  @media only screen and (width < 845px) {\n    .hat-column-right-products,\n    .flex-hat-products-right-column {\n      max-width: 40rem;\n    }\n  }\n\n  @media only screen and (width < 814px) {\n    .hat-column-right-products,\n    .flex-hat-products-right-column {\n      max-width: 39rem;\n    }\n  } */\n  /* @media only screen and (width < 400px) {\n    .flex-hat-products-right-column {\n    }\n  }\n  \n  @media only screen and (width >= 400px) {\n    .hat-column-right-products {\n    }\n  }\n  @media only screen and (width >= 500px) {\n    .flex-hat-products-right-column {\n    }\n  }\n  @media only screen and (width >= 600px) {\n    .flex-hat-products-right-column {\n    }\n  }\n  @media only screen and (width >= 768px) {\n    .flex-hat-products-right-column {\n    }\n  }\n  @media only screen and (max-width: 1087px) {\n    .flex-hat-products-right-column {\n      max-width: 54rem;\n    }\n  }\n\n  @media only screen and (width >= 1200px) {\n    .flex-hat-products-right-column {\n    }\n  } */\n}\n\n/*Max-width is basically saying 500px, if youre in that this will happen*/\n@media all {\n  /* xs, extra-small: 0px\n    sm, small: 600px\n    md, medium: 900px\n    lg, large: 1200px\n    xl, extra-large: 1536px */\n\n  @media only screen and (max-width: 844px) {\n    .flex-hat-products-right-column,\n    .loading-div-products,\n    .bottom-text-products-logos {\n      margin-left: 2rem;\n    }\n  }\n\n  @media only screen and (min-width: 845px) {\n    .flex-hat-products-right-column {\n      margin-left: 0rem;\n    }\n  }\n  /* Extra small devices (phones, 600px and down) */\n  /* @media only screen and (width >= 400px) {\n    .hat-column-right-products {\n      margin-left: 4rem;\n      max-width: fit-content;\n    }\n  } */\n  /* @media only screen and (width >= 500px) {\n    .hat-column-right-products {\n      margin-left: 7rem;\n      max-width: fit-content;\n    }\n  } */\n  /* Small devices (portrait tablets and large phones, 600px and up) */\n  /* @media only screen and (width >= 600px) {\n    .hat-column-right-products {\n      margin-left: 0rem;\n      max-width: fit-content;\n    }\n  } */\n  /* Medium devices (landscape tablets, 768px and up) */\n  /* @media only screen and (width >= 768px) {\n    .hat-column-right-products {\n      margin-left: 7rem;\n      max-width: fit-content;\n    }\n  } */\n  /* Large devices (laptops/desktops, 992px and up) */\n  /* @media only screen and (width >= 992px) {\n    .hat-column-right-products {\n      margin-left: 3rem;\n    }\n  } */\n  /* Extra large devices (large laptops and desktops, 1200px and up) */\n  /* @media only screen and (width >= 1200px) {\n    .hat-column-right-products {\n      margin-left: 10rem;\n    }\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
